import Vue from 'vue'
import Router from 'vue-router'
import jssdk from '../jssdk'
import store from '../store'
import { Loading, Message } from 'element-ui'
import { getUrlParams } from '@/utils/filterObjNull'

Vue.use(Router)
const changePush = Router.prototype.push;

Router.prototype.push = function push(location) {
	return changePush.call(this, location).catch(err => err);
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function (location) {
	return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('@/views/HomeView.vue'),
			meta: {
				keepAlive: true,
			},
		},
		// {
		// 	path: '/',
		// 	name: 'test',
		// 	component: () => import('@/views/test.vue')
		// },
		{
			path: '/feSkuList',
			name: 'feSkuList',
			component: () => import('@/views/skuList.vue'),
			meta: {
				keepAlive: false,
			},
		},
		{
			path: '/feTopicDetail',
			name: 'feTopicDetail',
			component: () => import('@/views/topicDetail.vue'),
		},
		{
			path: '/detailAll',
			name: 'detailAll',
			component: () => import('@/views/detailAll.vue')
		},
		{
			path: '/mine',
			name: 'mine',
			component: () => import('@/views/mine.vue')
		},
		{
			path: '/feTopicList',
			name: 'feTopicList',
			component: () => import('@/views/topicList.vue'),

		},
		{
			path: '/publish',
			name: 'publish',
			component: () => import('@/views/publishView.vue')
		},
	]
})

// 导航守卫处理全局逻辑
router.beforeEach((to, from, next) => {
	if (!window.initUrl) {
		window.initUrl = location.href.split('#')[0];
		console.log(77, '当前页面', window.initUrl)
	}
	if (to.name === 'error') {
		next()
		return
	}

	// 判断是否登陆
	if (store.state.isLogin) {
		next()
	} else {
		if (store.state.error) {
			Message.error(store.state.error)
			return
		}
		if (!store.state.loading) {
			store.commit('update', {
				loading: Loading.service({ fullscreen: true, text: '获取用户信息...' })
			})
		}
		jssdk.afterAuth(to.query)
		const query = getUrlParams('userid')
		next({ path: to.path, query })
		if (store.state.loading) {
			store.state.loading.close()
			store.commit('update', {
				loading: null
			})
		}
	}
})

// router.afterEach((to, from) => {
// 	console.log(87, to, to.hash)
// 	if (to.hash) {
// 		setTimeout(() => {
// 			var el = document.querySelector(to.hash);
// 			console.log(89, el)
// 			if (el) {
// 				window.scrollTo(0, el.offsetTop - 100); // 调整偏移量
// 			}
// 		}, 500)
// 	}
// })

// // 导航守卫处理全局逻辑
// router.beforeEach((to, from, next) => {
// 	if (to.name === 'error') {
// 		next()
// 		return
// 	}
// 	next()

// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js